import React, { useCallback, useEffect } from 'react';
import './App.css';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { Projects } from '../components/Projects/Projects';
import LinearProgress from '@mui/material/LinearProgress';
import ErrorSnackBar from '../components/common/ErrorSnackBar';
import { useDispatch, useSelector } from 'react-redux';
import { AppRootState } from './store';
import { initializeAppTC, RequestStatusType } from './app-reducer';
import { Login } from '../components/Login/Login';
import { Box, CircularProgress, createTheme, ThemeProvider } from '@mui/material';
import { checkAutoLogin, logoutTC } from '../components/Login/auth-reducer';
import { WorkItemData } from '../components/Task/WorkItemData';
import { WorkItemsList } from '../components/TasksList/WorkItemsList';
import { NewTaskData } from '../components/NewTask/NewTaskData';
import { Routes, useNavigate } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { NotFound } from '../components/NotFound';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import { getCurrentLocation } from './cookies';
import { ProjectDropList } from './ProjectDropList';
import { UserData } from '../components/Users/UserData';
import { AccountsList } from '../components/Accounts/AccountsList';
import { AccountData } from '../components/Accounts/AccountData';
import { NewAccountData } from '../components/Accounts/New account/NewAccountData';
import { NewUserData } from '../components/Users/NewUser/NewUserData';
import PersonIcon from '@mui/icons-material/Person';
import { CurrentUserData } from '../components/Users/CurrentUser/CurrentUserData';
import Badge from '@mui/material/Badge';
import { ResetPassword } from '../components/Login/ResetPassword';

const theme = createTheme({
  palette: {
    primary: {
      main: '#272727',
    },
    secondary: {
      main: '#ff0000',
    },
    info: {
      main:'#00a0d1'
    }
  },
});

export const AppWithRedux = React.memo(() => {
  const status = useSelector<AppRootState, RequestStatusType>(state => state.app.status)
  const isInitialized = useSelector<AppRootState, boolean>(state => state.app.initialized)
  const dispatch = useDispatch()
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const isAdminRole = useSelector<AppRootState, boolean>(state => state.auth.me.isAdminRole)
  const notificationsAmount = useSelector<AppRootState, number>(state => state.notification.amount)
  const navigate = useNavigate()

  useEffect(() => {
    console.log('isloggedin',isLoggedIn)
    dispatch(initializeAppTC())
    checkAutoLogin(dispatch)
  }, [isAdminRole])

  const logoutHandler = useCallback(() => {
    dispatch(logoutTC())
  }, [])

  if (!isInitialized) {
    return <CircularProgress color="info" style={{ position: 'fixed', top: '30%', left: '50%', width: 80, height: 80 }} />
  }

  return (
    <ThemeProvider theme={theme}>
    <>
      <div className="App">
        <ErrorSnackBar />
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" style={{backgroundColor: '#272727'}} >
            <Toolbar>
              <Typography variant="h6" sx={{ flexGrow: 1 }} >
              <span onClick={() => navigate(`/`)} className='toolbarSpan'><span style={{color: '#ff0000', fontWeight: 'bold' }}>web</span>quake BugTracker</span>  
                {isLoggedIn ? <span id='span'><ProjectDropList /></span> : ''}
              </Typography>
              {isLoggedIn ? <PersonIcon className='groupIcon' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => navigate(`/me/`)}/> : <></>}
              {isAdminRole === true && isLoggedIn ?
                <BadgeOutlinedIcon className='groupIcon' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => navigate(`/accountsList/`)} />
                : <></>}
              {isLoggedIn ? <>
                <Badge badgeContent={notificationsAmount} color="secondary">
                     {/* <NotificationsIcon style={{cursor: 'pointer' }} className='groupIcon'/> */}
                     <NotificationsIcon className='groupIcon'/>
                </Badge>
             
                <Button className='groupIcon' style={{ marginLeft:'10px', cursor: 'pointer', marginRight: '10px', fontWeight: 'bold' }} onClick={logoutHandler} color="inherit">Log out</Button> </>
                : <></>}
            </Toolbar>
          </AppBar>
          <div className="progressLine">
            {status === 'loading' && <LinearProgress color = 'info' value={50} />}
          </div>
          <Container>
            <div>
              {isLoggedIn ? <Typography style={{ color: 'grey', marginTop: '64px', fontStyle: 'italic' }} sx={{ flexGrow: 1 }}>Webquake BugTracker {getCurrentLocation()}
              </Typography> : ''}
            </div>
            <Routes>
              <Route path="/" element={<Projects />} />
              <Route path="/login" element={<Login />} />
              <Route path="/project/:projectName" element={<WorkItemsList />} />
              <Route path="/itemID/:itemid" element={<WorkItemData />} />
              <Route path="/newWorkItem/" element={<NewTaskData />} />
              <Route path="/accountsList/" element={<AccountsList />} />
              <Route path="/me/" element={<CurrentUserData />} />
              <Route path="/accountsList/:accountId" element={<AccountData />} />
              <Route path="/accountsList/newAccount" element={<NewAccountData />} />
              <Route path="/usersList/:userId" element={<UserData />} />
              <Route path="/usersList/newUser" element={<NewUserData />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="/resetPasswort" element={<ResetPassword />} />
            </Routes>
          </Container>
        </Box>
      </div>
    </>
    </ThemeProvider>
  );
})
